import React, { useEffect, useRef, useState } from 'react';
import * as L from 'leaflet';
import PropTypes from 'prop-types';

function Leaflet({ lat, long, zoom }) {
  const root = useRef(null);
  const mapRef = useRef();
  const markerRef = useRef();
  const [stylesInitialized, setStylesInitialized] = useState(false);
  const [error, setError] = useState();

  useEffect(() => {
    const doc = root.current.ownerDocument;
    createLeafletStyles(doc)
      .then(() => setStylesInitialized(true))
      .catch(err => setError(err));
  }, [root]);

  useEffect(() => {
    if (!mapRef.current && stylesInitialized) {
      mapRef.current = L.map(root.current);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '© OpenStreetMap',
      }).addTo(mapRef.current);
    }

    if (mapRef.current) {
      // Set the view to the specified coordinates and zoom level
      mapRef.current.setView([lat, long], zoom);

      // Create a custom pointer icon
      const pointerIcon = L.icon({
        iconUrl: '/assets/map/pointer.png',
        iconSize: [32, 32], // adjust the size of the icon
        iconAnchor: [16, 32], // adjust the anchor point of the icon
      });

      // Create a marker with the custom pointer icon at the specified coordinates
      if (!markerRef.current) {
        markerRef.current = L.marker([lat, long], { icon: pointerIcon }).addTo(mapRef.current);
      } else {
        // If the marker already exists, update its position and icon
        markerRef.current.setLatLng([lat, long]);
        markerRef.current.setIcon(pointerIcon);
      }
    }
  }, [stylesInitialized, lat, long, zoom]);

  return (
    <div style={{ height: 300, width: '100%' }}>
      {error ? error.message : <div style={{ width: '100%', height: '100%', background: 'black' }} ref={root} />}
    </div>
  );
}

async function createLeafletStyles(doc) {
  let styles = doc.getElementById('leaflet-css');
  if (styles) {
    return Promise.resolve(); // Ensure a Promise is always returned
  }
  const res = await fetch('https://esm.sh/leaflet/dist/leaflet.css');
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}: ${res.statusText}`);
  }
  const css = await res.text();
  styles = doc.createElement('style');
  styles.id = 'leaflet-css';
  styles.appendChild(doc.createTextNode(css));
  doc.head.appendChild(styles);
  return Promise.resolve(); // Return a promise after appending the styles
}

Leaflet.propTypes = {
  lat: PropTypes.number.isRequired,
  long: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
};

export default Leaflet;
